import React, { useEffect, useState } from "react";
import moment from "moment";
import { Button } from "reactstrap";
import { connect } from "react-redux";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { ONE_WAY_MESSAGE_TRAILER } from "../../../utils/constants";
import ThreadedConversationView from "./ThreadedConversationView";
import parse from 'html-react-parser'
import {
  isRichMessageBody,
  messageTextPreserveSpacing,
  sanitizeMessageBodyHtml,
} from "../../../utils/normalizeText";
import { getTextFromLanguageCodeAndKey } from "../languages";
import { getUserContentWarningText } from "../../../utils/userContentWarning";

// `trivvyLanguage` is optional: MyMessages renders this component without it,
// and an undefined code resolves to English.
const MessagingSurvey = ({
  isOpenQuiz,
  orgId,
  quizData,
  quizExternalUserData,
  trivvyLanguage,
  user,
  previewOnly,
  userContentWarning,
}) => {
  const showUserContentWarning =
    (userContentWarning === true ||
      (quizData && quizData.userContentWarning === true)) &&
    !(quizData && quizData.isOneWay === true)
  const [showHistory, setShowHistory] = useState(false);
  const [success, setSuccessMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [responses, setResponses] = useState([]);
  const [openConversations, setOpenConversations] = useState(new Set());
  const [conversationData, setConversationData] = useState({});
  const params = new URLSearchParams({
    email: quizExternalUserData ? quizExternalUserData.email : null,
    mobileNumber: quizExternalUserData
      ? quizExternalUserData.mobileNumber
      : null,
    employeeId: quizExternalUserData ? quizExternalUserData.employeeId : null,
  });

  const handleGetMessageHistory = () => {
    const condUrl = quizExternalUserData
      ? url.getMessagingResultHistoryById(quizData._id, params)
      : url.getMessagingResultHistoryByIdForSpecificUser(quizData._id, params);
    axios.get(condUrl).then(({ data }) => {
      if (data.data && data.data.length > 0) {
        const modifiedData = data.data
          .filter((response) => response.messagingResponse)
          .map((response) => ({
            text: response.messagingResponse.text,
            createdOn: response.createdOn,
            _id: response._id,
            conversationMessageCount: response.conversationMessageCount || 1,
          }));
        setResponses(modifiedData);
      } else {
        setResponses([]);
      }
    });
  };

  const fetchConversation = async (messageId) => {
    try {
      var conversationUrl = (user && user.profile && (user.profile.tokens || user.profile._id))
        ? url.getTriviaConversation(messageId)
        : url.getTriviaConversationPublic(messageId);
      const res = await axios.get(conversationUrl);
      if (res && res.data && res.data.success && res.data.messages) {
        setConversationData(prev => ({
          ...prev,
          [messageId]: res.data.messages
        }));
      }
    } catch (err) {
      console.error("Error fetching conversation", err);
    }
  };

  const openConversationModal = (message) => {
    setOpenConversations(prev => new Set([...prev, message._id]));
    // Fetch conversation data if not already loaded
    if (!conversationData[message._id]) {
      fetchConversation(message._id);
    }
  };

  const closeConversationModal = (messageId) => {
    setOpenConversations(prev => {
      const newSet = new Set(prev);
      newSet.delete(messageId);
      return newSet;
    });
  };

  useEffect(() => {
    handleGetMessageHistory();
  }, []);

  const handleMessageSubmit = () => {
    // Never submit a real messaging response from the Edit-page preview.
    if (previewOnly) {
      return;
    }
    setSuccessMessage(false);
          
    setLoading(true);
     setResponses((prevResponse) => [
          ...prevResponse,
          {
            text: message,
            createdOn: moment().toISOString(),
          },
        ]);
    setMessage("");
    const urlCond = quizExternalUserData
      ? url.submitMessagingResponseForExternalUser(quizData._id)
      : url.submitMessagingResponse(quizData._id);
    axios
      .post(urlCond, {
        message,
        isAnonymous: quizData.isAnonymous,
        triviaId: quizData._id,

        isOpenQuiz: isOpenQuiz,
        userData: {
          email: quizExternalUserData ? quizExternalUserData.email : null,
          name: quizExternalUserData ? quizExternalUserData.name : null,
          mobileNumber: quizExternalUserData
            ? quizExternalUserData.mobileNumber
            : null,
          employeeId: quizExternalUserData
            ? quizExternalUserData.employeeId
            : null,
          firstName: quizExternalUserData
            ? quizExternalUserData.firstName
            : null,
          lastName: quizExternalUserData ? quizExternalUserData.lastName : null,
        },
        orgId,
        ...(quizData.createdBy &&
          quizData.createdBy._id && {
            triviaCreatedBy: {
              userId: quizData.createdBy._id,
              firstName: quizData.createdBy.firstName,
              lastName: quizData.createdBy.lastName,
              profilePic: quizData.createdBy.profilePic,
            },
          }),
        ...(isOpenQuiz && {
          shareLinkMedium:
            new URLSearchParams(window.location.search).get("medium") || "SMS",
        }),
      })
      .then((res) => {
        
       setMessage("");
        setSuccessMessage(true);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, "err here");
        setSuccessMessage(false);
        setLoading(false);
      });
  };

  return !quizData ? (
    <div>Loading...</div>
  ) : (
    <div
      style={{
        display: "flex",
        flexDirection: 'column',
       // justifyContent:'center',
       marginTop:'5%',
        alignItems:'center',
        width: "100%",
      }}
    >
      <div className="mb-3 messaging-survey-left">
        <h3 className="color-orange mb-0 rich-title-tight" style={{fontSize:'30px !important'}}>{parse(quizData.name || "Messaging Survey")}</h3>
        {quizData.createdOn&&<p className="mb-3"> {moment
                    .utc(quizData.createdOn)
                    .local()
                    .format("MMM D, YYYY [at] h:mm A")}</p>}
        {/* div, not p: a rich body renders <p> and nesting them is invalid. */}
        <div className="mb-3 text-size rich-body-tight">
          {isRichMessageBody(quizData.messagingSubject)
            ? parse(sanitizeMessageBodyHtml(quizData.messagingSubject))
            : messageTextPreserveSpacing(quizData.messagingSubject)}
        </div>
        {/* 3.a.i (take screen): show the 1-way trailer below the message body so
            the recipient who opens the message via email link sees the same line
            appended to the sent SMS. Styled like the body so it reads as part of
            the message. */}
        {quizData && quizData.isOneWay === true && (
          <p className="mb-3 text-size">{ONE_WAY_MESSAGE_TRAILER}</p>
        )}
        {showUserContentWarning && (
          <p className="text-muted mt-2 mb-3">
            <small>{getUserContentWarningText(trivvyLanguage)}</small>
          </p>
        )}

        <div className="mb-3">
          <div className="">
            <textarea
              rows="4"
              id="eid"
              className="form-control text-size"
              onChange={(e) => {
                setMessage(e.target.value);
              }}
              value={message}
              placeholder="type your message... "
              autoComplete="off"
              style={{
                background: "white",
               // fontSize:'1rem'
              }}
            />
          </div>
          {success && (
            <div className="mt-2">
              <span>
                {getTextFromLanguageCodeAndKey(
                  trivvyLanguage,
                  "messageSubmittedSuccess"
                )}
              </span>
            </div>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "10px",
            }}
          >
            <div className="flex">
              <Button
                disabled={previewOnly || message.trim() === "" || loading}
                className="mr-2 color-orange bg-white"
                onClick={handleMessageSubmit}
              >
                {loading
                  ? getTextFromLanguageCodeAndKey(trivvyLanguage, "sending")
                  : getTextFromLanguageCodeAndKey(trivvyLanguage, "submit")}
              </Button>
              {responses.length > 0 && (
                <Button
                  className="color-orange bg-white"
                  onClick={() => setShowHistory((prevState) => !prevState)}
                >
                  {!showHistory ? "Show History" : "Hide History"}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      {showHistory && responses.length > 0 && (
        <div className="messaging-survey-right">
          <p className="text-size">Your Messaging History</p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "10px",
              height: "300px",
              overflowY: "auto",
              gap: "12px",
            }}
          >
            {responses.map((message) => (
              <div 
                className="text-size"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "2px",
                  width: "100%",
                }}
              >
                {/* Message content in white box */}
                <div style={{
                  background: "white",
                  padding: "10px",
                  borderRadius: "8px",
                  width: "100%",
                }}>
                  {message.text}
                </div>

                {/* Time and View Replies button below message - both on left side */}
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  marginTop: "5px",
                  paddingLeft: "10px",
                }}>
                  <span style={{
                    fontSize: "10px",
                    color: "#666",
                    fontWeight: "normal",
                    marginBottom: "2px",
                  }}>
                    {moment
                      .utc(message.createdOn)
                      .local()
                      .format("MMM D, YYYY [at] h:mm A")}
                  </span>
                  
                  {/* "View all [X] replies" button below timestamp */}
                  {message.conversationMessageCount > 1 && !openConversations.has(message._id) && (
                    <button
                      className="view-replies-btn"
                      onClick={() => openConversationModal(message)}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "inherit",
                        fontSize: "12px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        padding: "2px 6px",
                        borderRadius: "4px",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "#f0f0f0";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "transparent";
                      }}
                    >
                      View all {message.conversationMessageCount - 1} {message.conversationMessageCount === 2 ? "reply" : "replies"}
                    </button>
                  )}
                </div>
                
                {/* Inline Threaded Conversation View */}
                {openConversations.has(message._id) && (
                  <div style={{ marginTop: "15px", borderTop: "1px solid #e9ecef", paddingTop: "15px" }}>
                    <ThreadedConversationView
                      messages={conversationData[message._id] || []}
                      isLoading={!conversationData[message._id] && message._id}
                      onClose={() => closeConversationModal(message._id)}
                      id={message._id}
                      user={user}
                      adminAId={quizData.createdBy && quizData.createdBy._id}
                      onNewMessage={(updatedMessages) => {
                        // Update the conversation data with new message
                        setConversationData(prev => ({
                          ...prev,
                          [message._id]: updatedMessages
                        }));
                        
                        // Increment the conversationMessageCount
                        setResponses(prev => prev.map(resp => 
                          resp._id === message._id 
                            ? { ...resp, conversationMessageCount: (resp.conversationMessageCount || 1) + 1 }
                            : resp
                        ));
                      }}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
          </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,

    quizData: state.trivia.currentQuizData,

    triviaResponses: state.trivia.triviaResponses,
    quizResultObjectId: state.trivia.quizResultObjectId,
    quizExternalUserData: state.trivia.quizExternalUserData,
    currentQuizLinkedRewards: state.trivia.currentQuizLinkedRewards,
    ratingSubmitted: state.trivia.ratingSubmitted,
  };
};

export default connect(mapStateToProps)(MessagingSurvey);
